import { FC } from 'react';

import { ACCOUNT_CARD_COLOR, AccountCard } from 'utils/types';
import { cn } from 'utils/helpers';
import { upperCase } from 'lodash';

import { useGetColorGradient } from '../hooks';

type PROPS = {
  accountCard: AccountCard;
};

const CardContactInfo: FC<PROPS> = ({ accountCard }) => {
  const gradient = useGetColorGradient(
    accountCard?.meta?.color as ACCOUNT_CARD_COLOR,
  );

  return (
    <div
      className={cn(
        'min-h-[174px]',
        'bg-cover',
        'p-[23px]',
        'flex',
        'flex-col justify-between',
        'text-[#FFFFFF]',
      )}
      style={{
        backgroundImage: `linear-gradient(150deg, ${gradient[0]}, ${gradient[1]})`,
      }}
    >
      <div className="flex items-center space-x-3">
        {accountCard?.meta?.companyLogoUrl && (
          <img
            src={accountCard?.meta?.companyLogoUrl}
            alt={accountCard?.meta?.companyLogoUrl}
            className="w-[50px] h-[50px]"
          />
        )}
        {accountCard?.meta?.companyName && (
          <h1 className="text-xs font-semibold">
            {upperCase(accountCard?.meta?.companyName)}
          </h1>
        )}
      </div>
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <h1 className="text-xl font-semibold">
            {accountCard?.meta?.fullName}
          </h1>
          {accountCard?.meta?.jobTitle && (
            <h2 className="text-sm font-thin">{accountCard?.meta?.jobTitle}</h2>
          )}
        </div>
        {accountCard?.meta?.photoUrl && (
          <div className="rounded-md overflow-hidden bg-fill-primary">
            <img
              src={accountCard?.meta?.photoUrl}
              alt={accountCard?.meta?.photoUrl}
              className="w-[48px] h-[48px]"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CardContactInfo;
